import { SpaceMd, SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
const warehouseIconStyles = {
  height: SpaceMd,
  width: SpaceMd
};
const warehouseTextDivStyles = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  gap: SpaceXxs
};
export {
  warehouseIconStyles,
  warehouseTextDivStyles
};
